import { computed } from 'vue'
import store from '@/store'
import appConstants from '@/constants/constants'
import router from '@/router'
import navMenuItems from '@/navigation/horizontal'
import { getSystemModules } from '@/composables/currentUser'
import ability from '@/libs/acl/ability'

export default function useApp() {
  const isFirefoxBrowser = navigator.userAgent.toLowerCase().includes('firefox')
  const isDarkLayout = computed(() => store.state.appConfig.layout.skin === 'dark')
  const featherIconTypes = [
    appConstants.app.featherIcon.types.DOLLAR_SIGN_ICON, appConstants.app.featherIcon.types.INFO_ICON,
    appConstants.app.featherIcon.types.PHONE_ICON, appConstants.app.featherIcon.types.SETTINGS_ICON,
    appConstants.app.featherIcon.types.USERS_ICON, appConstants.app.featherIcon.types.EXTERNAL_LINK_ICON,
    appConstants.app.featherIcon.types.ARROW_UP_ICON, appConstants.app.featherIcon.types.ARROW_DOWN_ICON,
    appConstants.app.featherIcon.types.CLOCK_ICON, appConstants.app.featherIcon.types.ARROW_UP_CIRCLE_ICON,
    appConstants.app.featherIcon.types.ARROW_DOWN_CIRCLE_ICON, appConstants.app.featherIcon.types.FILTER_ICON,
    appConstants.app.featherIcon.types.TRASH_ICON, appConstants.app.featherIcon.types.X_ICON,
    appConstants.app.featherIcon.types.ARROW_UP_RIGHT_ICON, appConstants.app.featherIcon.types.HOME_ICON,
    appConstants.app.featherIcon.types.USER_ICON, appConstants.app.featherIcon.types.EYE_ICON,
    appConstants.app.featherIcon.types.BOOK_OPEN_ICON, appConstants.app.featherIcon.types.FILE_TEXT_ICON,
    appConstants.app.featherIcon.types.EDIT_ICON, appConstants.app.featherIcon.types.REFRESH_CW_ICON,
    appConstants.app.featherIcon.types.COPY_ICON, appConstants.app.featherIcon.types.TOOL_ICON,
    appConstants.app.featherIcon.types.X_OCTAGON_ICON, appConstants.app.featherIcon.types.CHECK_CIRCLE_ICON,
    appConstants.app.featherIcon.types.MINUS_ICON, appConstants.app.featherIcon.types.LINK_ICON,
    appConstants.app.featherIcon.types.FOLDER_ICON, appConstants.app.featherIcon.types.MAIL_ICON,
    appConstants.app.featherIcon.types.LOG_OUT_ICON, appConstants.app.featherIcon.types.CIRCLE_ICON,
    appConstants.app.featherIcon.types.DISC_ICON, appConstants.app.featherIcon.types.BELL_ICON,
    appConstants.app.featherIcon.types.ALERT_TRIANGLE_ICON, appConstants.app.featherIcon.types.ALERT_CIRCLE_ICON,
    appConstants.app.featherIcon.types.SEARCH_ICON, appConstants.app.featherIcon.types.LOG_IN_ICON,
    appConstants.app.featherIcon.types.SAVE_ICON, appConstants.app.featherIcon.types.ARCHIVE_ICON
  ]
  const bModalSizes = [
    appConstants.app.bModalSizes.XL, appConstants.app.bModalSizes.LG, appConstants.app.bModalSizes.MD,
    appConstants.app.bModalSizes.XS
  ]
  const numbersList = Array.from({ length: 10 }, (_, i) => i.toString())

  const getHomePageRouteName = () => getFirstAvailableRouteName(navMenuItems, getSystemModules())
  const goToHomePage = () => {
    const homeRouteName = getHomePageRouteName()
    if (router.currentRoute.name !== homeRouteName) {
      return router.push({ name: homeRouteName })
    }
    return null
  }
  const getFirstAvailableRouteName = (navMenuItems, systemModules) => {
    for (let i = 0; i < navMenuItems.length; i++) {
      const routeIndex = systemModules.findIndex(m => m === navMenuItems[i].route)
      if (routeIndex > -1) {
        if (navMenuItems[i].children) {
          const target = getFirstAvailableRouteName(navMenuItems[i].children, systemModules)
          if (target) {
            return target
          }
        } else {
          const routeIndex = router.options.routes.findIndex(r => r.name === navMenuItems[i].route)
          if (routeIndex > -1) {
            const route = router.options.routes[routeIndex]
            if (
              route.meta
              && (
                Array.isArray(route.meta.resource)
                  ? route.meta.resource.some(r => ability.can(route.meta.action || 'read', r))
                  : ability.can(route.meta.action || 'read', route.meta.resource)
              )
            ) {
              return navMenuItems[i].route
            }
          }
        }
      }
    }
  }
  const preventDigits = e => {
    if (numbersList.includes(e.key)) {
      e.preventDefault()
    }
  }
  const getCurrentTime = () => new Date().getTime()

  return {
    isDarkLayout,
    featherIconTypes,
    bModalSizes,
    isFirefoxBrowser,
    
    goToHomePage,
    getHomePageRouteName,
    preventDigits,
    getCurrentTime,
  }
}
